import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { Container, Row, Col, Button, Form, FormGroup, Input, Label } from 'reactstrap'

const ImpressumPage = () => (
  <div>
    <Helmet
      title={`Impressum`}
    />
    <section className="bg-light">
      <Container>
        <Row className="align-items-center pt-5 pt-lg-7">
          <Col>
            <h1>Impressum <small className="text-muted">gem. §5 E-Commerce Gesetz.</small></h1>
          </Col>
        </Row>
        <Row className="pt-5 pt-lg-7">
          <Col xs="6" md="4">
            <h5 className="text-uppercase">Adresse</h5>
            <address>
              Thomas Schmidleithner, BSc<br />
              Grolzham 2D<br />
              4680 Weibern<br />
              Österreich
            </address>
          </Col>
          <Col xs="6" md="4">
            <h5 className="text-uppercase">Telefon</h5>
            <p>+43 664 14 555 90</p>
          </Col>
          <Col md="4">
            <h5 className="text-uppercase">Email</h5>
            <p>
              <a href="mailto:thomas@schmidleithner.at">thomas@schmidleithner.at</a>
            </p>
          </Col>
        </Row>
        <Row className="pb-5 pb-lg-7 align-items-center">
          <Col md="4" className="mt-5">
            <h5 className="text-uppercase">UID-Nummer</h5>
            <p>ATU72845228</p>
          </Col>
          <Col md="6" className="mt-5">
            <p>Mitglied der Wirtschaftskammer Oberösterreich, Fachgruppe Unternehmensberatung, Buchhaltung und Informationstechnologie</p>
          </Col>
        </Row>
      </Container>
    </section>

    <section className="border-top">
      <Container>
        <Row className="py-7">
          <Col>
            <h2 className="mb-3">Rechtlicher Hinweis.</h2>
            <p>Die Inhalte dieser Website werden ständig aktualisiert und geprüft. Trotz aller Sorgfalt kann keinerlei Gewähr für die Aktualität, Vollständigkeit und Richtigkeit der auf dieser Webseite bereitgestellten Informationen übernommen werden. Eine Haftung oder Garantie hierfür kann daher nicht übernommen werden. Gleiches gilt auch für alle anderen Webseiten, auf die mittels eines Hyperlinks von dieser Webseite verwiesen wird. Für den Inhalt der Webseiten, die aufgrund einer solchen Verbindung erreicht werden können, sind wir nicht verantwortlich. Daher erklären wir ausdrücklich, dass zum Zeitpunkt der Linksetzung die verlinkte Webseite frei von illegalen Inhalten war.</p>
            <p>Wir behalten uns das Recht vor, Ergänzungen, Änderungen oder Löschungen der auf dieser Webseite bereitgestellten Informationen jederzeit und ohne Ankündigung vorzunehmen oder die Veröffentlichung zeitweise oder endgültig einzustellen.</p>
            <p>Inhalte und Struktur der Webseite serverless.at sind urheberrechtlich geschützt. Die Vervielfältigung von Informationen oder Daten, insbesondere die Verwendung von Texten, Textteilen, Soundfiles oder Bildmaterial bedarf der vorherigen schriftlichen Zustimmung des Herausgebers.</p>
          </Col>
        </Row>
      </Container>
    </section>
  </div>
)

export default ImpressumPage



// WEBPACK FOOTER //
// ./src/pages/impressum.js